/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useEffect, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import BtnPrincipal from 'src/components/Buttons/BtnPrincipal';
import Timer from 'src/components/Counter';
import FooterButton from 'src/components/FooterBtn/FooterButton';
import NavbarHeader from 'src/components/header/NavbarHeader';
import InfoPtp from 'src/components/InfoPtp';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import withCotizacion from 'src/HOC/withCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import useLoading from 'src/hooks/useLoading';
import usePtp from 'src/hooks/usePtp';
import { guardarLead } from 'src/services';

const PtpPrimerPagoSuscripcion = ({ cotizacion, idCotizacion, addSuccessToast }) => {
  const { idSuscripcion } = useParams<any>();

  const { values, setLoading, resetLoading, setSecundario } = useLoading();
  const history = useHistory();
  const { hacerPrimerPago, ESTADOS_PAGO, consultarEstadoPago } = usePtp();

  const { addWarningToast } = useCustomToast();

  const [estadoPago, setEstadoPago] = useState('');
  const [estadoPago2, setEstadoPago2] = useState({});

  const [verificando, setVerificando] = useState(false);

  const init = async () => {
    setLoading(true);
    setSecundario('Estamos realizando el primer pago...');
    const pagEstado = await hacerPrimerPago(idSuscripcion);
    if (pagEstado?.hasError) {
      return addWarningToast('Ha ocurrido al procesar tu pago.');
    }
    guardarLead(idCotizacion, `P2P_PRIMER_PAGO_SUSCRIPCION__ESTADO_PAGO_${pagEstado?.estado}`);
    setEstadoPago2(pagEstado?.data);
    switch (pagEstado?.estado) {
      case ESTADOS_PAGO.APROBADO:
        addSuccessToast(
          `Su pago se ha realizado exitosamente.\n No.transaccion: ${pagEstado?.data?.pago_id}`,
        );
        setEstadoPago(ESTADOS_PAGO.APROBADO);
        // history.push(`/ingresarPoliza/${idCotizacion}`);
        redireccionar()
        break;
      case ESTADOS_PAGO.RECHAZADO:
        setEstadoPago(ESTADOS_PAGO.RECHAZADO);
        break;
      case ESTADOS_PAGO.PENDIENTE:
        setEstadoPago(ESTADOS_PAGO.PENDIENTE);
        break;
      default:
        break;
    }
    resetLoading();
  };

  useEffect(() => {
    guardarLead(idCotizacion, 'P2P_PRIMER_PAGO_SUSCRIPCION__INGRESO');
    init();
  }, []);

  useEffect(() => {
    let bucle = null;
    if (estadoPago === ESTADOS_PAGO.PENDIENTE) {
      bucle = setInterval(async () => {
        setVerificando(true);
        const res = await consultarEstadoPago();
        guardarLead(idCotizacion, `P2P_PRIMER_PAGO_SUSCRIPCION__ESTADO_PAGO_SONDA_${res?.estado}`);
        if (res.hasError) {
          addWarningToast('Ha ocurrido un problema al consultar el estado de tu pago');
        } else {
          if (
            ESTADOS_PAGO.APROBADO === res.estado ||
            ESTADOS_PAGO.SIN_PAGOS_PENDIENTES === res.estado
          ) {
            clearInterval(bucle);
            // history.push(`/ingresarPoliza/${idCotizacion}`);
            redireccionar()
          }
          setVerificando(false);
        }
      }, 60000);
    }

    return () => {
      clearInterval(bucle);
    };
  }, [estadoPago, idCotizacion]);

  const redireccionar = () => {
    if (`${cotizacion.producto.tieneFirma}` === '1') {
      switch (cotizacion.medioFirma) {
        case 'evicertia': return history.push(`/firmarCertificado/${idCotizacion}`);
        case 'fisica': return history.push(`/ingresarPoliza/${idCotizacion}/`);
        case 'token': return history.push(`/verificarTokenPago/${idCotizacion}/${idCotizacion}`);
        default:
          // addErrorToast('Cotizacion no tiene el medio para la firma', { autoDismiss: false });
          break;
      }
    } else {
      return history.push(`/ingresarPoliza/${idCotizacion}/`);
    }
  }

  const onClickIntentarNuevamente = () => {
    history.push(`/newPaginaCompra/${idCotizacion}`);
  };

  return (
    <LoadingWrapper {...values}>
      <div className="container-fluid container-page">
        <NavbarHeader showBack={false} />
        <InfoPtp
          valor={cotizacion?.valoresPagar?.total}
          resultado={estadoPago}
          referencia={idCotizacion}
          pago={estadoPago2}
          label="Primer pago"
          periocidadPago="Primera cuota"
        >
          <React.Fragment>
            {estadoPago === ESTADOS_PAGO.RECHAZADO && (
              <div className="col-10 col-sm-8 text-center mt-5">
                <h6 className="label__rechazado">
                  Su petición de suscripción de tarjeta ha sido <strong>rechazada</strong>
                </h6>
              </div>
            )}
            {estadoPago === ESTADOS_PAGO.PENDIENTE && !verificando && (
              <div className="col-10 col-sm-8 mt-5">
                <h5 className="label__pendiente font-weight-bold text-secondary text-justify">
                  Al parecer el proceso de verificación está tardando más de lo esperado, pronto
                  seras notificado a tu correo {' '}{cotizacion.titular.email}
                </h5>
                <h5 className="label__timer mt-3">
                  Se volvera a consultar en <Timer initialTime={55000} direction="backward" />
                </h5>
              </div>
            )}
            <BtnPrincipal
              label="Mis pagos"
              onClick={() => history.push(`/listado-pago/${idCotizacion}/${cotizacion.empPtp}`)}
            />
            {verificando && (
              <div className="col-10 col-sm-8">
                <ProgressBar
                  className="progresbar__pendiente my-5"
                  animated
                  now={100}
                  label="Verificando estado..."
                />
              </div>
            )}
          </React.Fragment>
        </InfoPtp>
      </div>
      {estadoPago === ESTADOS_PAGO.RECHAZADO && (
        <FooterButton label="Intentar otra vez" onClick={onClickIntentarNuevamente} />
      )}
    </LoadingWrapper>
  );
};

export default withCotizacion(PtpPrimerPagoSuscripcion);
